import React, { useEffect, useState } from 'react';
import InfoDialog from '../../../components/shared/InfoDialog';
import { API_MAILING } from '../../../api/mailing';
import TabsLanguage from '../../../components/widgets/TabsLanguage';
import ShowContainer from '../../../components/material-ui/ShowContainer';
import { Box } from '@mui/material';
import BtnCopy from '../../../components/bonus/ui/BtnCopy';
import useToast from '../../../hooks/useToast';

export default function MessageDialog({ open, onClose, messageId }) {
  const { infoToast } = useToast();
  const [messages, setMessages] = useState({});
  const [lang, setLang] = useState('');

  useEffect(() => {
    if (!open) return;
    if (!messageId) return;

    API_MAILING.message({ mailingId: messageId })
      .then((res) => {
        const messages = res.data.list || {};
        setMessages(messages);
        setLang(Object.keys(messages)[0] || '');
      })
      .catch(console.error);

    return () => {
      setMessages({});
      setLang('');
    };
  }, [messageId, open]);

  const onCopyClick = () => {
    const myMessage = message
      // .replaceAll(/<br\s*\/?>/gi, '\n')
      .replaceAll('&nbsp;', ' ');
    // .replaceAll('<p>', '')
    // .replaceAll('</p>', '\n');
    navigator.clipboard.writeText(myMessage).then((e) => {
      infoToast('copied to your clipboard');
    });
  };

  const languages = Object.keys(messages);
  const message = messages[lang];

  return (
    <InfoDialog
      open={open}
      onClose={onClose}
      title="Message"
      actions={message && <BtnCopy variant="text" iconSize={22} onClick={onCopyClick} />}>
      <ShowContainer condition={languages.length} plug={<Box sx={{ height: 120 }} />}>
        <TabsLanguage myLanguage={languages} lang={lang} setLang={setLang} />
        <ShowContainer condition={message}>
          <div dangerouslySetInnerHTML={{ __html: message }} />
        </ShowContainer>
      </ShowContainer>
    </InfoDialog>
  );
}
